/**
 * 拼接参数
 * @param url
 * @param params
 * @returns 返回处理的URL
 */
export const joinParameters = <T = any>(url: string, params?: { [key: string]: string | number | boolean } & T) => {
  if (!params) {
    return url;
  }
  const keys = Object.keys(params);
  const str = keys.map((value) => `${value}=${encodeURIComponent(params[value])}`).join('&');

  url += url.indexOf('?') < 0 ? '?' : '&';

  return `${url}${str}`;
};

/**
 * 获取参数
 * @param key
 * @param url
 * @returns 返回参数值
 */
export const getQueryString = (key: string, url: string = window.location.href) => {
  const [, params] = url.split('?');
  const query = new URLSearchParams(params);
  const value = query.get(key);

  return value ? decodeURIComponent(decodeURIComponent(value)) : value;
};
